import { render, staticRenderFns } from "./RecommendLink.vue?vue&type=template&id=9bedb104&"
import script from "./RecommendLink.vue?vue&type=script&lang=js&"
export * from "./RecommendLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports